import { render } from "./NoOrga.vue?vue&type=template&id=3442744f"
const script = {}

import exportComponent from "C:\\Users\\Admin\\Documents\\LoesusPedagogia\\ArchiV2\\LP-Hub\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__